const SvgCheckCircleIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    {...props}
  >
    <path
      stroke="#35AC4F"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M10 18.333c4.584 0 8.334-3.75 8.334-8.333S14.584 1.667 10 1.667 1.667 5.417 1.667 10s3.75 8.333 8.333 8.333"
    />
    <g clipPath="url(#check-circle-icon_svg__a)">
      <path
        fill="#35AC4F"
        d="M13.16 7.18a1 1 0 0 0-.148.056c-.046.022-.696.66-2.117 2.081l-2.051 2.05-.894-.894c-.63-.628-.916-.903-.966-.928a.67.67 0 0 0-.907.899c.04.082.18.23 1.114 1.16l1.067 1.065.133.062c.304.146.6.146.906 0l.133-.062 2.223-2.22c2.427-2.426 2.292-2.282 2.335-2.508.085-.464-.37-.883-.827-.761"
      />
    </g>
    <defs>
      <clipPath id="check-circle-icon_svg__a">
        <path fill="#fff" d="M6 6h8v8H6z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgCheckCircleIcon;
